import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className={`flex justify-between items-center z-[999999] transition-all duration-300 ${
      isHome ? "py-[15px] md:py-[47px]" : "py-1 md:py-3"
    }`}>
      <Link to="/" className="w-[80px] sm:w-[130px] hover:opacity-80 transition-opacity">
        <img src="/img/webpImg/Tbd-Logo.webp" alt="Logo" />
      </Link>

      <div className="flex items-center gap-4 sm:gap-10">
        <Link
          to="/amazon-deals"
          className="text-[#3145a8] hover:text-[#2c3562] font-black text-xs sm:text-base uppercase tracking-widest transition-colors"
        >
          Amazon Deals
        </Link>

        <Link
          to={
            "https://play.google.com/store/apps/details?id=com.the_best_dealsApp"
          }
          className="bg-[#7E54F2] w-fit text-[#FFF] text-center text-xs sm:text-sm font-medium leading-normal tracking-[0.334px] uppercase sm:px-[20px] px-[14px] py-[9px] sm:py-[13px] rounded-[42px] flex items-center justify-center cursor-pointer shadow-md hover:shadow-lg transition-shadow"
        >
          Install App
        </Link>
      </div>
    </div>
  );
}

export default Navbar
